import { actions, selectors } from 'app-webtech-core';
import format from 'date-fns/format';
import platform from 'platform';
import { properties as desktopSelector } from 'app-modules/desktop/selectors';
import { checkMobileOperatingSystem } from 'app-modules/application/utils/checkMobileOperatingSystem';
import uuid from 'uuid/v4';
import { processPixels } from './utils/pixels';

const awaitDeviceConfigured = (dispatch, getState) => async (resolve) => {
  const state = getState();
  const { isConfigured } = selectors.device.properties(state);
  const desktopState = desktopSelector(state);
  const deviceType = desktopState.enabled ? 'desktop' : 'web';

  if (isConfigured) {
    resolve();
  } else {
    const deviceStored = JSON.parse(localStorage.getItem('persist:root'));
    const initDevice =
      deviceStored && deviceStored.application
        ? JSON.parse(deviceStored.device)
        : {
            ID: uuid(),
            type: deviceType,
            make: platform.name,
            version: platform.version,
            userAgent: navigator.userAgent,
            DNT: false,
          };
    delete initDevice.isConfigured;
    delete initDevice.error;
    await dispatch(actions.device.configure(initDevice));
    resolve();
  }
};

const awaitDeviceReady = (dispatch, getState) =>
  new Promise(awaitDeviceConfigured(dispatch, getState));

const setupBeaconThunkAction = () => async (dispatch, getState) => {
  await awaitDeviceReady(dispatch, getState);
  const device = selectors.device.properties(getState());
  const { query } = getState().location || { query: undefined };
  const {
    utm_campaign: utmCampaign = 'na',
    utm_content: utmContent = 'na',
    utm_medium: utmMedium = 'na',
    utm_source: initUtmSource,
    utm_term: utmTerm = 'na',
    client_embed_partner: clientEmbedPartner = 'na',
  } = query || {};
  const { isTablet, isMobile } = checkMobileOperatingSystem();
  // eslint-disable-next-line no-nested-ternary
  const clientDeviceType = isTablet ? 5 : isMobile ? 4 : 2;
  const utmSource = initUtmSource || (getState().location.type.includes('VIRAL') ? 'viral' : 'na');


  const init = {
    // for help and hardcoded values, see
    // https://docs.google.com/spreadsheets/d/14j1tdP9gfrd6xRbIzR0sWt1eknZTXC5QZOP4kGGy1cw/edit#gid=484893717
    browserName: device.make,
    browserVersion: device.version,
    carrierName: 'na',
    clientChipset: 'na',
    clientDeviceType,
    clientEmbedPartner,
    clientFirmware: 'na',
    clientID: device.ID,
    clientLanguage: (navigator && navigator.language) || 'na',
    clientManufacturer: 'na',
    clientModelName: 'na',
    clientModelNumber: 'na',
    clientNetworkType: 'na',
    clientOS: (platform && platform.os && platform.os.toString()) || 'na',
    clientTimezone: `UTC${format(Date.now(), 'xx')}`,
    clientScreenResolution: 'na',
    environment: process.env.NODE_ENV === 'production' ? 'prod' : 'test',
    eventGeneratorName: 'na',
    eventGeneratorType: 'client',
    eventEmitterName: 'na',
    eventEmitterType: 'client',
    isClientDNT: device.DNT,
    myPlutoID: 'na',
    networkBandwidth: -1,
    playerName: 'Hls',
    playerVersion: 'na', // TODO. VidePlayer.jsx:~140. Move to config to get version
    plutoUID: 'na',
    profileID: 'na',
    referrer: document.referrer || 'na',
    userAgent: device.userAgent,
    userPostalCode: 'na',
    userLatitude: 'na',
    userLongitude: 'na',
    userInteractionMode: 'na',
    utmCampaign,
    utmContent,
    utmMedium,
    utmSource,
    utmTerm,
  };
  await dispatch(actions.application.setup(init));

  processPixels(getState);
};

export { setupBeaconThunkAction as setupBeacon };
